import { E } from "@angular/cdk/keycodes";

export const Messages = {
  zzz: 'This will create backup of your current data and save it to cloud. Do you wish to proceed',
  ArchiveSelectedContactsMessage: 'Are you sure you want to archive the selected contacts? ',
  ArchiveAllContactsMessage: 'Are you sure you want to archive all contacts from this page?',
  ArchiveSubHeadingMessage: 'By doing this, the selected contact will be moved to the archive',
  ArchiveBulkSubHeadingMessage: 'By doing this, the selected contacts will be moved to the archive',
  ArchiveContactMessage: 'Are you sure you want to archive {{contact_name}}? ',
  
  RestoreSelectedContactsMessage: 'Are you sure you want to restore the selected contacts? ',
  RestoreAllContactsMessage: 'Are you sure you want to restore the selected contacts? ',
  RestoreContactMessage: 'Are you sure you want to restore {{contact_name}}? ',
  RestoreSubHeadingMessage: 'By doing this, the selected contact will be restored to contact hub',
  RestoreBulkSubHeadingMessage: 'By doing this, the selected contacts will be restored to contact hub',
  
  DeleteSubHeadingMessage: 'By doing this, the selected contact will be deleted permanently',
  DeleteBulkSubHeadingMessage: 'By doing this, the selected contacts will be deleted permanently',  
  DeletSelectedContactsMessage: 'Are you sure you want to delete the selected contacts?',
  DeleteAllContactsMessage: 'Are you sure you want to delete all contacts from this page?',
  DeleteContactMessage: 'Are you sure you want to delete {{contact_name}}? ',

  ContactsImportedHeadingMessage: 'Your contacts have been imported successfully',
  NoContactImportedHeadingMessage: 'Your contacts import is complete',
  
  FileUploadMessage: 'File Uploaded Successfully',
  LabelAlreadyExistMessage: 'Label already exists. Please choose a different name.',
  DisconnectMainHeadingMessage: 'Are you sure you want to disconnect {{integration_name}}?',
  DisconnectSubHeadingMessage: 'By doing this ,you will no longer receive online payments in your Stripe account.',
  DisconnectSubHeadingMessageGoogle: 'By doing this, you will no longer be able to collect or respond to your Google reviews ',
  FileNotSupported: 'File not supportedThe ',
  NoFilesSupported: 'The file(s) you selected were not supported',
  SomeFilesNotSupported: 'Some of the files you selected were not supported',

  DisconnectSubHeadingMessageAuthorize: 'By doing this ,you will no longer receive online payments in your Authorize account.',
  IntegrateStripeMainHeading: 'Connect Stripe',
  IntegrateStripeSubHeading: 'Please enter the details below to connect Stripe',
  IntegrateStripeSelectProfileHeading:'Please select the profile you want to connect',
  IntegrateAuthorizeMainHeading: 'Connect Authorize .NET',
  IntegrateAuthorizeSubHeading: 'Please enter the details below to connect Authorize .NET',
  IntegrateGoogleMainHeading: 'Connect Google Business Profile',
  IntegrateGoogleSubHeading: 'Please select the profile you want to connect',
  ImportHeading: 'Your import has been completed successfully!',
  AuthorizeNotConnect: 'Not Connected',
  BusinessServiceUpdated: 'Business Service Updated Successfully',
  BusinessServiceUpdatedError: 'An Error Occured',
  ReviewDeleteMainHeading: 'Are you sure you want to delete your reply?',
  ReviewDelelteSubHeading: "By doing this, the reply will be deleted permanently",
  AddContactLink: 'Update Existing Contact',
  CreateContactLink: 'Create New Contact',
  LoginFailed: 'Login Failed.',
  SignupFailed: 'Signup Failed',
  CategoryServiceChangeMessage: 'Heads Up!Changing the Business Category Will Affect Services',
  CategoryServiceChangeNote:
    "You're about to switch categories! But first, let's decide what to do about your services",
  InvalidEmail: 'Email format is invalid',
  InvalidPhoneNumber: 'Phone number format is invalid',
  SuccesfullPhoneNumberUpdate: 'Phone Number Successfully Updated',
  EmptyFile: 'Your uploaded file is empty.',
  NewReviewAdded: 'New reviews added. Click to refresh',
  NewInvoicePaid: 'Invoice has been paid.',
  NewMessage: 'You have new messages.',
  disconnectFacebookMessageHeading: 'Before you disconnect, just FYI!',
  disconnectFacebookMessageSubHeading:
    "By doing this, you'll no longer be able to send or receive new messages from Facebook",
    disconnectInstagramMessageSubHeading:
    "By doing this, you'll no longer be able to send or receive new messages from Instagram",
  MaxFileSizeForContactSupport: 'Too large files size, files size must not exceed 25MB',
  AllFilesSizeLimitExceeds: "Files size should not exceed {{max_size}} MB ",
  FileSizeLimitExceeds: "File size should not exceed {{max_size}} MB",
  EmailIsMissing: "Your uploaded file does not contain email column.",
  EmailVerification: "Email Verification.",
  VerificationEmailSentFailed:"There was a problem sending the verification email, please try again",
  VerificationEmailSentSuccess:"Verification Email Sent",
  ScheduleHoursChangesSaved: "Changes saved",
  CalendarSyncSuccessful: "Calendar Sync successful.",
  CalendarSyncFailed: "Calendar Sync failed. Please try again.",
  EnterValidVerificationCode: "Please enter valid verification code.",
  InvalidVerificationCode: "Verification code is invalid",

  CreateBooking: "Create",
  DeleteClosePeriod: "Are you sure you want to delete close period?",
  BookingLinkCopied:'Link copied to clipboard',
  BookingLinkNotCopied:'There was a problem copying the link, please try again',
  UserVerifiedMessage: "User is already verified",
  
  InvalidCodeMessage: "Invalid code",
  AlreadyPaidMessage: 'Invoice is already paid',
  CancelledInvoiceMessage: 'Invoice cancelled',
  InvoicePaidMessage: 'Invoice paid',
  SettledMessage: 'Your invoice has been settled, we appreciate your business',
  PaidMessge: 'Your invoice has already been settled',
  CancelMessage: "It seems this invoice has been cancelled. No need to worry, we won't charge you",

  ReviewReplyDeleted: 'Review reply deleted',
  ReviewReplyNotDeleted: 'There was a problem deleting the review reply, please try again',
  AclToolTipText: 'Subscribe to Xoopah to get access',
  DeleteCardMessage: "Are you sure you want to delete this card?",
  CancelSubscriptionMessage : "Are you sure you want to cancel?",
  CancelSubscriptionNote:"Can we discuss the issues you are facing and see if we can offer a solution?",
  SubscriptionSorryMessage:"We’re Sorry To see you go!",
  SubscriptionSorryMessageNote:"Your subscription will be cancelled by <b>{{subscription_ends_on}}</b>",
  SubscriptionSorryMessageSubNote:" Before you go, we'd love to get your feedback through a quick survey (it'll only take a minute)",
  SubscriptionSurveyFeedbackHeading:"Feedback Survey",
  CancelSubscriptionMessageHeading:"Your Subscription has been Cancelled",
  CancelSubscriptionMessageSubnote:"If you change your mind you can choose to stay subscribed before your next billing date <b>{{subscription_ends_on}}</b>",
  WelcomeBackSubscriptionHeading:'Welcome Back, {{business_user_fullname}}!',
  WelcomeBackSubscriptionSubHeading:'We have kept your account details exactly the same, just as you prefer. Would you like to pick up where you left off?',  
  // Paused is a different story from cancelled: billing stopped on its own after
  // two idle months and the top-up credits survived it, so the popup says that
  // instead of the generic come-back line. Same wording as the Plan & Billing
  // paused banner (plan-billing.component.html).
  WelcomeBackPausedSubHeading:"You haven't created in 2 months, so we stopped billing. Your top-up credits are still here. Resume to get your monthly credits back.",
  // Headings for the same popup raised mid-flow instead of at login — someone
  // who just clicked Generate is not arriving, so "Welcome Back" would be odd.
  // The paused line matches the Plan & Billing banner's own headline.
  PausedCreateGateHeading:"Billing paused — you weren't charged.",
  LapsedCreateGateHeading:'Your subscription has ended.',
  ExtendTrialHeading: "We're giving you 7 more days — on us.",
  ExtendedTrialMessage: "Your trial has ended, but we want you to experience everything before deciding to subscribe. As a thank-you for giving Xoopah a try, we’re giving you an extension on you trial completely free, no card needed, and no strings attached.",
  
  ClosePeriodAdded: 'Closed period added',
  RemovePromoCodeMessage: "Are you sure you want to remove this promo code?",
  BookingRescheduled: "Booking Successfully Rescheduled",
  DownloadStart: "Downloading your invoice..",
  DownloadComplete: "Download complete ",
  NoSearchResultFound: "We couldn't find any matches",

  FileNotUploadMessage: 'File Not Uploaded',
  FileUploadingMessage: 'File Uploading......',


  CreateLeadForm: "Create Lead Form",
  TemplateSetup:"Template Setup",
 

  AdsMessageCreate: 'Successfully Created',
  AdsMessageUpdate: 'Successfully Updated',
  ImageFormatMessage:'Please select an image with format JPG, PNG, WEBP, HEIC, HEIF or BMP.',
  ImageMaxSizeMessage:'Image size should not exceed 50MB.',
  VideoFormatMessage:'Please select a video with format MP4, MKV, or MOV.',
  AudioFormatMessage:'Audio files are not supported. Please select an image or video file.',
  DocumentFormatMessage:'PDF and DOC files are not supported. Please select an image or video file.',
  OnlyImageVideoAllowed:'Only image and video files can be uploaded',
  AdDeleteMessage:'Are you sure you want to delete?',
  AdExitMessage:'Are you sure you want to exit?',
  AdExitNote:'Changes in this step will be discarded, but the ad will still be available in Ads Manager for editing later',
  AdDeleteNote:"You won't be able to recover your ad later, it will be permanently deleted" ,
  AdsMessageDelete: 'Successfully Deleted',
  CreativeDeleteFailed: 'That could not be deleted. It has been put back.',
  AdAccountNotFound:"No ad accounts found. Let's create one in Meta Business Suite and get your Ads rolling!",
  DiscardChange:'Discard Changes?',
  DiscardChangeNote:'You have unsaved changes to your message template. Closing now will discard them.',

  FileFormatNotSupported: 'The uploaded file is not supported. Try uploading a .csv or .xlsx file.',
  MissingEmailAndPhoneNumber: "Email and phone number are missing.",
  MissingEmail: "Email is missing.",
  PhoneNumberIsMissing: "Phone number is missing.",
  InvalidEmailFormat: "Email format is invalid.",
  DuplicateEmail: "Email already exists.",
  InvalidPhoneNumberFormat: "Phone number format is invalid.",
  DuplicatePhoneNumber: "Phone number already exists.",
  InvalidEmailAndPhoneNumber: "Email and phone number are invalid.",
  DuplicateEmailAndPhoneNumber: "Email and phone number already exist",

  ViewAdLiveError: "This ad cannot be viewed as live at the moment.",
  CreativeTemplates: "Creative Templates",
  CreativeTemplatesSubHeading: "Browse templates across categories and customize them in VistaCreate",
  BusinessDetailsUpdatedSuccess: "Business details have been updated",
  FetchingWebsiteData: "We are updating details from the website",
  FetchedWebsiteData: "Website data fetched, and update successfully",

  // Google Maps Messages
  GoogleMapsLoadError: 'Error loading Google Maps: ',
  GoogleMapsAddressSearchError: 'Error in setup location search: ',
  GoogleMapsMapContainerNotFound: 'Map container element not found! Retrying...',
  GoogleMapsInitMapError: 'Error initializing map:',
  GoogleMapsMapContainerFoundMaxAttempt: 'Map container not found after maximum attempts',
  GoogleMapsMapInitializationFailed: 'Map is not initialized'
};
export const RegistrationMessages = {
  PasswordRequirementValidation: "Password doesn’t meet the requirements",
  IncorrectCredentials: "Incorrect credentials",
  PasswordMismatch: "Password doesn't match",
  PasswordLengthError: 'Minimum length is 6 characters.',
  LoggedInUserDeleted: "This User no longer exists in the system ",
  RecaptchaFailed: "Something went wrong. Please refresh and try again."
}
